export default __webpack_public_path__ + "static/media/wrong.a68f02c9.svg";